import React from 'react'
import talksList from './data/data.json'
import ScheduleItem from '../ScheduleItem'

import ReactDOM from 'react-dom';

// 'Minimal' theme - hide/show the AccordionBody component:
import 'react-accessible-accordion/dist/minimal-example.css';
 
import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';

class Schedule extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
        <Accordion className="schedule" id="schedule">
        <h2 className="tickets-title">Speakers</h2>
        <AccordionItem>
            <AccordionItemTitle>
                <header className="schedule-header">
                    <span className="schedule-header_time">08:30</span>
                    <div className="schedule-header_wrapper">
                        <h3 className="schedule-header_name">Doors open</h3>
                    </div>
                </header>
            </AccordionItemTitle>
            <AccordionItemBody>
                <p className="item-text schedule-body">Coffee! And registration and breakfast :)</p>
            </AccordionItemBody>
        </AccordionItem>

        <AccordionItem>
            <AccordionItemTitle>
                <header className="schedule-header">
                    <span className="schedule-header_time">09:20 - 09:30</span>
                    <div className="schedule-header_wrapper">
                        <h3 className="schedule-header_name">Conference welcome</h3>
                    </div>
                </header>
            </AccordionItemTitle>
            <AccordionItemBody>
                <p className="item-text schedule-body">Hello, everyone!</p>
            </AccordionItemBody>
        </AccordionItem>
        
        {talksList.map(talk => (
            <ScheduleItem key={talk.id} presenter={talk.presenter} title={talk.title} description={talk.description} time={talk.time} space={talk.break} />
        ))}
      </Accordion>
    )
  }
}

export default Schedule


// WEBPACK FOOTER //
// ./src/components/Schedule/index.js